"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonOption = void 0;
const Colors_1 = require("../../Colors");
exports.ButtonOption = {
    buttonAfterIcon: {
        className: undefined,
        show: false,
        name: undefined,
        size: 10,
        color: Colors_1.Colors.grey,
        stroke: Colors_1.Colors.transparent,
    },
    buttonBeforeIcon: {
        className: undefined,
        show: false,
        name: undefined,
        size: 10,
        color: Colors_1.Colors.grey,
        stroke: Colors_1.Colors.transparent,
    },
};
